import { PublicServiceHealthSummary, ServiceStatus } from '@/types/service/serviceHealth';

import { getServiceDisplayName, getStatusColor } from '@/utils/statusPageHelpers';

import UptimeChart from './UptimeChart';

interface ServiceStatusRowProps {
  service: PublicServiceHealthSummary;
}

const ServiceStatusRow = ({ service }: ServiceStatusRowProps) => {
  const colorClasses = getStatusColor(service.current_status);
  const displayName = getServiceDisplayName(service.service_type);

  const getStatusText = (status: ServiceStatus): string => {
    switch (status) {
      case ServiceStatus.OPERATIONAL:
        return 'Operational';
      case ServiceStatus.DEGRADED:
        return 'Degraded Performance';
      case ServiceStatus.DOWN:
        return 'Service Down';
      default:
        return 'Unknown';
    }
  };

  const isFundFit = service.service_type === 'fundfit';

  return (
    <div className='border-b border-gray-200 last:border-b-0 py-6'>
      <div className='space-y-4'>
        {/* Service Header */}
        <div className='flex items-center justify-between'>
          <div className='flex items-center gap-3'>
            <div className={`h-3 w-3 ${colorClasses.bg} rounded-full`} />
            <h3 className='text-base font-semibold'>
              {displayName}
              {isFundFit && (
                <span className='text-xs text-muted-foreground font-normal ml-2'>
                  (Integrated via Research)
                </span>
              )}
            </h3>
          </div>
          <span className={`text-sm font-medium ${colorClasses.text}`}>
            {getStatusText(service.current_status)}
          </span>
        </div>

        {/* Uptime Chart */}
        <UptimeChart metrics={service.daily_metrics} />
      </div>
    </div>
  );
};

export default ServiceStatusRow;
